module.exports = __webpack_public_path__ + "static/media/post1-sixnations.d15ac1d9.jpg";